import { GridEvents } from "@mui/x-data-grid-premium";
import { GridApiPremium } from "@mui/x-data-grid-premium/models/gridApiPremium";
import { MutableRefObject, useEffect } from "react";

interface UseAutosizeColumnsProps {
  apiRef: MutableRefObject<GridApiPremium>;
  autosizeColumns?: boolean;
}

const useAutosizeColumns = (props: UseAutosizeColumnsProps) => {
  const { apiRef } = props;

  // TODO: move this to a hook and make it configurable
  useEffect(() => {
    const ref = apiRef.current;

    if (!ref?.subscribeEvent) {
      return;
    }

    if (!props.autosizeColumns) {
      return;
    }

    const autosize = () => {
      if (props.autosizeColumns && apiRef.current?.getRowsCount() > 0) {
        console.log("useAutosizeColumns");

        setTimeout(() => {
          apiRef.current?.autosizeColumns({
            includeOutliers: true,
            includeHeaders: true,
            disableColumnVirtualization: true,
            expand: true,
          });
        }, 0);
      }
    };

    const subscribe = <E extends GridEvents>(event: E) => {
      subs.push(ref.subscribeEvent(event, autosize));
    };

    const subs: VoidFunction[] = [];

    subscribe('rowsSet');
    subscribe('pinnedColumnsChange');
    subscribe('columnVisibilityModelChange');

    return () => {
      subs.forEach(unsub => {
        unsub();
      });
    };
  }, [apiRef, props.autosizeColumns]);
};

export default useAutosizeColumns;